import { clsx } from 'clsx'
import { type FC } from 'react'

import { type SelectionEntry } from '../../product-page-context/useProductPageAttributeSelectionControls'
import { useProductPageRebrushStyle } from '../../product-page-context/useProductPageRebrushStyle'
import { useProductPageContext } from '../../productPageContext'
import { type ProductPrices, useProductPrices } from '../hooks/useProductPrices'

import { ProductPageVariantDetails } from './ProductPageVariantDetails'
import { ProductPageVariantQuantityAndUnitPrice } from './ProductPageVariantQuantityAndUnitPrice'
import { ProductPageVariantWrapper } from './ProductPageVariantWrapper'

type ProductPageVariantProps = {
  selectionEntry: SelectionEntry
}

export const ProductPageVariant: FC<ProductPageVariantProps> = ({
  selectionEntry,
}) => {
  const [candidateVariant] = selectionEntry.allCandidateVariants

  const { currentPrescriptionType, currentVariant, offerId } =
    useProductPageContext()
  const {
    formattedUnitPrice,
    isProductNotInCatalog,
    isProductOutOfSale,
    isProductOutOfStock,
  }: ProductPrices = useProductPrices({
    currentPrescriptionType,
    offerId,
    product: candidateVariant,
  })
  const isRebrushStyle = useProductPageRebrushStyle()

  const isProductNotAvailable =
    isProductNotInCatalog || isProductOutOfStock || isProductOutOfSale
  const isVariantSelected = currentVariant.upid === candidateVariant.upid

  return (
    <li
      className={clsx(
        'flex items-center',
        !isRebrushStyle && 'border-t border-t-dark-primary-min',
      )}
      data-qa-id="product-variants"
    >
      <ProductPageVariantWrapper
        candidateVariant={candidateVariant}
        isVariantSelected={isVariantSelected}
        selectionEntry={selectionEntry}
      >
        <div
          className={clsx(
            'mr-4 flex size-5 flex-none items-center justify-center rounded-full border bg-light-primary-low mobile-md:size-7',
            isVariantSelected
              ? 'border-dark-brand after:flex after:size-2.5 after:rounded-full after:bg-dark-brand mobile-md:after:size-3.5'
              : 'border-dark-primary-medium',
          )}
        />
        <ProductPageVariantQuantityAndUnitPrice
          formattedUnitPrice={formattedUnitPrice}
          isProductNotAvailable={isProductNotAvailable}
          isProductOutOfSale={isProductOutOfSale}
          quantity={selectionEntry.attribute.value}
        />
        <ProductPageVariantDetails candidateVariant={candidateVariant} />
      </ProductPageVariantWrapper>
    </li>
  )
}
